import { ListingTemoignages } from '@components/listing-temoignages/models';
import { Block } from '@shared/models';

export const listingTemoignagesMock: Block<ListingTemoignages> = {
  type: 'listing-temoignages',
  data: {
    title: 'Dans les coulisses de [[leur projet]]',
  },
};
